/**
 * Base API paths for different SRP endpoints
 */
export const PART_API_PATH = "/srp/api/part";
export const USERDATA_API_PATH = "/srp/user_data/multi_tenant/";
export const LIT_STRUCT_API_PATH = "/srp/api/literature-structure";
export const DOC_API_PATH = "/srp/api/documents/";
export const FUND_HOLDINGS_API_PATH = "/srp/api/fund-holdings";
export const FUND_CENTRE_API_PATH = "/srp/api/fund-centre";
export const PRICES_DATE_METADATA = "/srp/api/prices-date-metadata";
